import { api } from "../../api";

export type AivisSpeechQuery = {
  accent_phrases: AccentPhrase[];
  speedScale: number;
  pitchScale: number;
  intonationScale: number;
  volumeScale: number;
  prePhonemeLength: number;
  postPhonemeLength: number;
  outputSamplingRate: number;
  outputStereo: boolean;
  kana: string;
};

export type AivisSpeechSpeakerInfo = {
  id: number[];
  // AivisSpeech APIから渡される動的パラメータ群
  query: Partial<AivisSpeechQuery> & {
    [key: string]: string | number | boolean | AccentPhrase[] | undefined;
  };
};

// VOICEVOXと同じAccentPhrase, Mora型を使用
type AccentPhrase = {
  moras: Mora[];
  accent: number;
  pause_mora: Mora;
};

type Mora = {
  text: string;
  consonant: string;
  consonant_length: number;
  vowel: string;
  vowel_length: number;
  pitch: number;
};
export const EditQuery = (
  query: AivisSpeechQuery,
  speakerInfo: AivisSpeechSpeakerInfo
): AivisSpeechQuery => {
  const source = speakerInfo.query as Partial<AivisSpeechQuery>;
  const setIfDefined = <K extends keyof AivisSpeechQuery>(k: K) => {
    const v = source[k];
    if (v !== undefined) {
      query[k] = v as AivisSpeechQuery[K];
    }
  };
  (Object.keys(query) as (keyof AivisSpeechQuery)[]).forEach(setIfDefined);
  return query;
};

export const getSpeakers = async () => {
  const res = await api.aivisspeech.getSpeakers.query();
  return res;
};

export default EditQuery;
